<template>
<ValidationObserver class="col" tag="div" ref="form" v-slot="{ invalid, handleSubmit }">
    <Loading />
    <Message />

    <CForm method="post" @submit.prevent="handleSubmit(submit)">
        <CRow>
            <CCustomInput
                sm="12"
                vid="title"
                :name="$t('short_link.title')"
                rules="required"
                required
                v-model="shortLink.title"
            />

            <CCustomInput
                sm="12"
                vid="href"
                :name="$t('short_link.url')"
                rules="required|url"
                required
                v-model="shortLink.url"
                ltr
            />

            <CCustomInput
                v-if="!shortLink.id"
                sm="12"
                vid="href"
                :name="$t('short_link.key')"
                v-model="shortLink.key"
                ltr
            />

            <CCol sm="12">
                <CButton :disabled="invalid" type="submit"  color="primary" class="mt-3 px-4 float-right">{{ $t('submit') }}</CButton>
            </CCol>
        </CRow>

    </CForm>
</ValidationObserver>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    name: 'Form',

    props: {
        submit: {
            default() {},
            required: true,
        },
        shortLink: {
            default() {
                return {
                    title: '',
                    url: '',
                    key: null,
                }
            },
        },
    },

    data() {
        return {
            //
        }
    },

    computed: {
        ...mapGetters({
            //
        })
    },
}
</script>